<template>
  <div
    v-show="visible"
    class="info-block"
    :class="component_classes">
    <div class="info-block__block">
      <info-icon
        v-if="!hide_info_icon"
        class="info-block__block-info mr-10"/>
      <div class="info-block__block-text">
        <slot></slot>
      </div>
      <span
        v-if="can_close"
        @click="visible = !visible"
        class="ml-auto">
        <close-icon
          class="ml-10"/>
      </span>
    </div>
  </div>
</template>

<script>

import InfoIcon from "../../components/icons/InfoIcon";
import CloseIcon from "../../components/icons/CloseIcon";
export default {
  name: "InfoBlock",
  components: {CloseIcon, InfoIcon},
  props: {
    error: {
      type: Boolean,
      default: false
    },
    success: {
      type: Boolean,
      default: false
    },
    hide_info_icon: {
      type: Boolean,
      default: false
    },
    can_close: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    component_classes() {
      return {
        error: this.error,
        success: this.success,
      }
    }
  },
  data() {
    return {
      visible: true,
    }
  }
}
</script>
